export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
    visible: that.showDefaultImage,
  },
  {
    title: that.$l('goods_spec_label_orderGoodsSpecNo') || '产品规格编号',
    field: 'orderGoodsSpecNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_orderGoodsSpecName') || '产品规格名称',
    field: 'orderGoodsSpecName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_englishSize') || '英文尺寸',
    field: 'v_englishSize',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_spec') || '产品规格',
    field: 'spec',
    minWidth: 130,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'specInfo' },
  },
  {
    title: that.$l('goods_spec_label_inGroupQty') || '规格数量',
    field: 'inGroupQty',
    minWidth: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_qty') || '订购数量',
    field: 'qty',
    minWidth: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_materialDesc') || '面料说明',
    field: 'materialDesc',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_accessoriesDesc') || '辅料说明',
    field: 'accessoriesDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_technologyDesc') || '工艺要求说明',
    field: 'technologyDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_smallPackageDesc') || '小包装说明',
    field: 'smallPackageDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('goods_spec_label_innerPackageDesc') || '内包装说明',
    field: 'innerPackageDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('goods_spec_label_packageDesc') || '外包装说明',
  //   field: 'packageDesc',
  //   minWidth: 300,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('goods_spec_label_inPackageQty') || '装箱入数',
  //   field: 'inPackageQty',
  //   minWidth: 120,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.table_label_modified_by') || '修改人',
  //   field: 'modifyByName',
  //   minWidth: 120,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true
  // },
  // {
  //   title: that.$l('INDEX.table_label_modification_date') || '修改时间',
  //   field: 'modifyTime',
  //   minWidth: 170,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true
  // }
]
